// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__tp9Qu","modalBody":"MealsPop_modalBody__18rVz"};